import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PaginatorModule } from 'primeng/paginator';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonComponent } from './components/button/button.component';
import { HeaderComponent } from './components/header/header.component';
import { InputComponent } from './components/input/input.component';
import { FormErrors } from './components/form-errors/form-errors.component';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { MenuItemComponent } from './components/menu/menu-item/menu-item.component';
import { MenuComponent } from './components/menu/menu.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { RoleFilterPipe } from './pipes/role-filter.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TextareaComponent } from './components/textarea/textarea.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ProgressComponent } from './components/progress/progress.component';
import { PopupComponent } from './components/popup/popup.component';
import { DatePipe } from './pipes/date.pipe';
import { ObjectFilterPipe } from './pipes/object-filter.pipe';
import { GeneralFilterPipe } from './pipes/general-filter.pipe';
import { GeneralFilterComponent } from './components/general-filter/general-filter.component';
import { TableComponent } from './components/table/table.component';
import { CircleComponent } from './components/circle/circle.component';
import { ItemComponent } from './components/table/item/item.component';
import { CalendarModule } from 'primeng/calendar';
import { CalendarComponent } from './components/calendar/calendar.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { ItemFormComponent } from './components/table/item-form/item-form.component';
import { SelectComponent } from './components/select/select.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { SortPipe } from './pipes/sort.pipe';
import { SlicePipe } from './pipes/slice.pipe';
import { FileUploaderCropperComponent } from './components/file-uploader-cropper/file-uploader-cropper.component';
import { DeepObjectFilterPipe } from './pipes/deep-object-filter.pipe';
import { ModalComponent } from './components/modal/modal.component';
import { DialogModule } from 'primeng/dialog';
import { ImageCropperModule } from 'ngx-image-cropper';
import { StepperComponent } from './components/stepper/stepper.component';
import { StepperDirective } from './directives/stepper/stepper.directive';
import { SelectGroupComponent } from './components/select-group/select-group.component';
import { OneTimeDirective } from './directives/one-time/one-time.directive';
import { ShowDirective } from './directives/show/show.directive';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { CurrencyDirective } from './directives/currency/currency.directive';

import { ThousandPipe } from './pipes/thousand.pipe';
import { SelectOrganizationalStructureComponent } from './components/select-organizational-structure/select-organizational-structure.component';
import { DecimalDirective } from './directives/decimal/decimal.directive';
import { TableFilterPipe } from './pipes/table-filter.pipe';
import { FormErrorsHighlighterComponent } from './components/form-errors-highlighter/form-errors-highlighter.component';
import { PaginationBackComponent } from './components/pagination-back/pagination-back.component';
import { CustomTranslatePipe } from './pipes/custom-translate.pipe';

const COMPONENTS = [
  HeaderComponent,
  ButtonComponent,
  LoginFormComponent,
  InputComponent,
  MenuComponent,
  MenuItemComponent,
  TextareaComponent,
  SpinnerComponent,
  FormErrors,
  PaginationComponent,
  SpinnerComponent,
  FormErrors,
  ProgressComponent,
  PopupComponent,
  GeneralFilterComponent,
  TableComponent,
  PopupComponent,
  CircleComponent,
  ItemComponent,
  CalendarComponent,
  ItemFormComponent,
  SelectComponent,
  FileUploaderComponent,
  FileUploaderCropperComponent,
  ModalComponent,
  ModalComponent,
  StepperComponent,
  SelectGroupComponent,
  SelectOrganizationalStructureComponent,
  FormErrorsHighlighterComponent,
  PaginationBackComponent
]

const PIPES = [
  RoleFilterPipe,
  DatePipe,
  ObjectFilterPipe,
  GeneralFilterPipe,
  TableFilterPipe,
  SortPipe,
  SlicePipe,
  DeepObjectFilterPipe,
  ThousandPipe,
  CustomTranslatePipe,
  SafeHtmlPipe
]

const PAGES = [
  LoginPageComponent,
]

const SERVICES = [

]

const DIRECTIVES = [
  StepperDirective,
  OneTimeDirective,
  ShowDirective,
  CurrencyDirective,
  DecimalDirective]

const MODULES = [
  RouterModule,
  TranslateModule,
  CommonModule,
  // SidebarModule,
  FormsModule,
  ReactiveFormsModule,
  PaginatorModule,
  CalendarModule,
  MultiSelectModule,
  DialogModule,
  CheckboxModule,
  ImageCropperModule,
  TooltipModule,
  FroalaEditorModule,
  FroalaViewModule
]

@NgModule({
  declarations: [...COMPONENTS, ...PAGES, ...PIPES, ...DIRECTIVES],
  imports: [
    MODULES
  ],
  providers: [
    ...SERVICES,
    ...PIPES
  ],
  exports: [...COMPONENTS, ...PAGES, ...PIPES, ...DIRECTIVES]
})
export class MapfreAuditlibModule { }
